<template>
  <b-nav-item>
    <feather-icon
      size="21"
      icon="RefreshCwIcon"
      @click="syncDB"
    />
  </b-nav-item>
</template>

<script>
import { BNavItem, BAlert } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import PouchDB from 'pouchdb'

export default {
  components: {
    BNavItem,
    BAlert
  },
  data() {
    return {
      localDB: new PouchDB(localStorage.getItem('database')),
      remoteDB: new PouchDB(localStorage.getItem('url')+'/'+localStorage.getItem('database')),
    }
  },
  methods: {
    findFirstImageAttachmentKey(attachments) {
      if (!attachments || typeof attachments !== 'object') return null
      for (const key of Object.keys(attachments)) {
        const meta = attachments[key]
        const ct = (meta && meta.content_type) || ''
        if (/^image\//i.test(ct)) return key
        if (/\.(png|jpe?g|gif|webp|bmp|svg)$/i.test(key)) return key
      }
      return null
    },
    blobToDataUrl(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.onerror = reject
        reader.readAsDataURL(blob)
      })
    },
    async findSetting() {
      const resultSet = await this.localDB.find({ selector: { type: 'setting' } })
      if (resultSet.docs.length === 0) return
      const doc = resultSet.docs[0]
      const payload = { ...doc }
      const attKey = this.findFirstImageAttachmentKey(doc._attachments)
      if (attKey) {
        try {
          const blob = await this.localDB.getAttachment(doc._id, attKey)
          payload.imageBase64 = await this.blobToDataUrl(blob)
        } catch (err) {
          console.warn('Erreur lecture pièce jointe setting', err)
        }
      }
      if (payload._attachments) delete payload._attachments
      localStorage.setting = JSON.stringify(payload)
    },
    syncDB() {
      // alert(this.$route.path)
      this.$swal({
        icon: 'warning',
        title: '',
        text: 'Synchronisation en cours ...',
        footer: '',
        showConfirmButton: false,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
      this.localDB.sync(this.remoteDB)
      .on('complete', complete => {

        this.traitement()

      }).on('error', err => {
        this.$swal({
          icon: 'error',
          title: 'Oops...',
          text: 'Quelque chose s\'est mal passé !',
          footer: '',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
      })
    },
    async traitement() {
      await this.localDB.createIndex({
        index: { fields: ['id', 'type', 'commerciaux', 'commercial', 'categorie', 'fournisseur', 'codearticle', 'inactif'] },
      })

        await this.findSetting()

        // Lecture des document sur l'index de recherhe type=commercial
        await this.localDB.find({selector: { type: 'commerciaux', id: 'org.couchdb.user:'+localStorage.getItem('user') }}).then(result => {
          console.log('commercial', result.docs[0])
          localStorage.commercial = JSON.stringify(result.docs[0])
        })

        await this.$swal({
          icon: 'success',
          title: '',
          text: 'Synchronisation terminé ...',
          footer: '',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })

        // this.$router.push({ path: this.$route.path })
        // await this.$router.push({ path: this.$route.path })
        await this.$router.currentRoute
    }
  }

}
</script>
